<!-- 选手退赛查询 -->
<template>
<div class="page-form" >
    <PageBack :title="title" />
    <div class="detail-wrap">
        <el-table border :data="tableData" style="width: 100%;" v-loading="loading">
            <el-table-column type="index"   label="序号"   width="60" align="center"/>
            <el-table-column  prop="username"   label="选手姓名"  align="center"/>
            <el-table-column  prop="phone"  label="手机号"  align="center"/>
            <el-table-column  prop="company"  label="协会（俱乐部）"  align="center"/>
            <el-table-column  prop="status"  label="状态"  align="center">
                <template  slot-scope="scope">
                    <el-tag >{{ scope.row.status }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column  prop="signDate" label="取消日期"  width="160" align="center"/>
            <el-table-column  fixed="right" label="操作" width="180">
                <template slot-scope="scope"> 
                    
                </template>  
            </el-table-column>
        </el-table>
        <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="initData"
        />
    </div>
</div>
</template>

<script>
import pagination  from '@/components/Pagination'
import PageBack from '@/components/PageHeader'
export default {
     components:{
        pagination,
        PageBack,
    },
    data() {
        return {
            publishId: '',
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],   
            total: 0,
            loading: false,
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
    },
    created() {
        this.publishId = this.$route.query.id
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.EventQuitQuery,
                i_serial_mark: this.publishId
            }
            this.loading = true
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){ 
                    this.loading = false                   
                    let result  = res.Data.DataTable
                    this.total  = res.Data.SumCount
                    this.tableData = result.map(item=>{
                        return {
                            username: item['选手名称'],
                            phone: item['选手手机号'],
                            signDate: this.$help.formatDate(item['报名日期']) +' '+ this.$help.formatTime(item['报名时间']),
                            serail: item['赛事标识'],
                            userId: item['选手账号'],
                            status: item['状态'],
                            company: item['协会（俱乐部）']
                        }
                    })
                }else{
                    this.loading = false   
                    this.$message.error(res.Message)
                }
            }).catch(err=>{
                console.log(err)
            })
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/publish/quitQuery.vue